import React, { memo, useEffect } from "react";
import { Row, Col } from "reactstrap";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { formatTime } from "../../../../helpers/time.helper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import { combineProps } from "../../../../helpers/objectHelper";
import { VideoCallMessage } from "./VideoCallMessage";

export const MessageBubble = memo(
  ({
    message = "",
    timeStamp,
    name,
    chatAlias,
    likes = 0,
    chatAdmin,
    fromYou,
    likeMessage = () => null,
    interactionChatId,
    chatTemplate,
    senderOrderId,
    senderFirstName,
    orderList,
    senderLastName,
    senderCompanyName,
    sender,
    receiver,
    lang,
    tickCode
  }) => {
    const { messages, primaryColor } = chatTemplate;
    return (
      <div style={{ width: "95%", textAlign: fromYou ? "right" : undefined }}>
        <Row style={{ width: "100%", margin: 0 }} className={"chat-box " + (fromYou ? "messages--sent--wrapper " : "messages--received--wrapper")}>
          <Col
            style={{
              display: "flex",
              justifyContent: fromYou ? "flex-end" : "flex-start",
            }}
            className={
              fromYou
                ? message.toString().includes("*!")
                  ? "messages messages--sent yell"
                  : "messages messages--sent"
                : message.toString().includes("*!")
                  ? "messages messages--received yell"
                  : "messages messages--received"
            }
          >
            {message.toString() == "THUMB_UP" ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <SenderNameInfo
                  {...combineProps([
                    {
                      messages,
                      chatAdmin,
                      chatAlias,
                      senderLastName,
                      senderCompanyName,
                      senderFirstName,
                      senderLastName,
                      senderOrderId,
                      fromYou,
                      sender,
                      tickCode
                    },
                  ])}
                />
                <div
                  style={{
                    position: "relative",
                    padding: "5px 0px",
                    backgroundColor: "transparent",
                  }}
                  className={"thumb"}
                >
                  <ThumbUpIcon
                    style={{
                      color: primaryColor,
                    }}
                  />
                </div>
              </div>
            ) : (
              <div
                style={{
                  fontFamily: messages.fontFamily,
                  lineHeight: "normal",
                  fontSize: messages.fontSize,
                  fontWeight: messages.fontWeight,
                  /* maxWidth: "90%", */
                  color: chatAdmin ? messages.adminTextColor : fromYou ? messages.sender.color : messages.receiver.color,
                  background: chatAdmin ? messages.adminBackgroundColor : fromYou ? messages.sender.backgroundColor : messages.receiver.backgroundColor,
                }}
                className={"message bubble"}
              >
                <SenderNameInfo
                  {...combineProps([
                    {
                      messages,
                      chatAdmin,
                      chatAlias,
                      orderList,
                      color: fromYou ? messages.sender.color : messages.receiver.color,
                      senderLastName,
                      senderCompanyName,
                      senderFirstName,
                      senderLastName,
                      senderOrderId,
                      fromYou,
                      sender,
                      tickCode
                    },
                  ])}
                />
                {parseMessage(message, fromYou, sender, receiver, chatTemplate)}

                <div
                  style={{ color: primaryColor }}
                  onClick={() => (message.toString() != "THUMB_UP" ? likeMessage(interactionChatId) : null)}
                  className={"liked-message-box" + (likes < 1 ? " empty-like" : "")}
                >
                  <ThumbUpIcon
                    style={{
                      color: primaryColor,
                    }}
                  />{" "}
                  {likes > 0 ? likes : ""}
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
);

const SenderNameInfo = memo(({ messages, color, chatAdmin, chatAlias, fromYou, senderCompanyName, senderFirstName, senderLastName, senderOrderId, sender, tickCode }) => {
  return (
    <div
      style={{
        color: chatAdmin ? messages.adminTextColor : color,
        fontFamily: messages.fontFamily,
        lineHeight: "normal",
        fontSize: messages.titleSize,
        fontWeight: "bold",
      }}
    >
      {!senderOrderId ?
        (sender.toLowerCase().startsWith("sneakyspy") ? <SystemLabel name="JirangoChatSupport" /> :
          (sender.startsWith(tickCode) ? <EventLabel2 name="EventModeratorChatName" groupName="DigitalMeeting.Chat" /> :
            <SystemLabel name="AnonymousClient" />
          )) : chatAdmin == true ? (
            chatAlias ? (
              chatAlias
            ) : (
              `${senderFirstName} ${senderLastName}` + (senderCompanyName ? ` • ${senderCompanyName}` : "")
            )
          ) : (
          `${senderFirstName} ${senderLastName}` + (senderCompanyName ? ` • ${senderCompanyName}` : "")
        )}
    </div>
  );
});

const TimeStamp = ({ messages, timeStamp, lang }) => {
  if (!timeStamp) return null;
  return (
    <div style={{ color: messages.color, opacity: 0.8 }} className={"time-stamp-da"}>
      <AccessTimeIcon style={{ fontSize: 12, margin: "0px 3px" }} />
      {formatTime(timeStamp, lang)}
    </div>
  );
};

const parseMessage = (message, fromYou, sender, receiver, chatTemplate) => {
  if (message.includes("VIDEO_CALL_INVITATION")) {
    return <VideoCallMessage {...{ sender, receiver, chatTemplate }} />;
  }
  if (message.includes("JX_ADMIN_REMOVED:")) return null; /* (
      <div style={{ display: "inline-flex" }}>
        <BlockIcon
          style={{ color: fromYou ? "#fff" : "#333", marginRight: 10 }}
        />
        <em style={{ paddingTop: 2 }}>
          <EventLabel2
            name="ThisMessagesIsBlocked"
            groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP}
          />{" "}
        </em>
      </div>
    ); */
  if (message.includes("https://")) return <ChatLink fromYou={fromYou} text={message.toString().replace("*!", "")} />;
  else return message.toString().replace("*!", "");
};

const ChatLink = ({ text, linkStyle, fromYou = false }) => {
  const urlify = () => {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    let url = "";
    text.replace(urlRegex, function (u) {
      url = u;
    });
    return url;
  };
  const textify = () => {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    let style = fromYou ? "text-decoration: underline; color: #fff;cursor: pointer;" : "text-decoration: underline; color: #2a40fe;cursor: pointer;";
    return text.replace(urlRegex, function (url) {
      return `<a href="${url}" style="${style}" target="_blank" >${url} </a>`;
    });
  };
  const content = textify();
  return <div dangerouslySetInnerHTML={{ __html: content }} />;
};
